import AntPagination from "antd/es/pagination";
import styled, { css } from "styled-components";

export const paginationStyles = css`
  .ant-pagination-item a,
  .anticon-right svg,
  .anticon-left svg,
  .ant-pagination-item-ellipsis {
    color: ${(p) => p.theme.colors.textColor} !important;
  }
  .ant-pagination-item-active a {
    color: ${(p) => p.theme.colors.primaryBlue}!important;
  }
  .ant-pagination-item-link,
  .ant-pagination-item-active,
  .ant-pagination-item {
    background: ${(p) => p.theme.colors.cardBgColor};
  }
  .ant-pagination-disabled .anticon svg {
    color: ${(p) => p.theme.colors.secondaryGrey};
  }
  .ant-pagination-item-link,
  .ant-pagination-item {
    border-color: ${(p) => p.theme.colors.lightestGrey}!important;
  }
  .ant-pagination-item-active,
  .ant-pagination-item:hover,
  .ant-pagination-item a:hover,
  .ant-pagination-item-link:hover,
  .ant-pagination-item-link:hover .anticon svg {
    border-color: ${(p) => p.theme.colors.primaryBlue}!important;
    color: ${(p) => p.theme.colors.primaryBlue}!important;
  }
  .ant-pagination-disabled > .ant-pagination-item-link {
    &:hover {
      border-color: ${(p) => p.theme.colors.lightestGrey}!important;
      .anticon svg {
        color: ${(p) => p.theme.colors.secondaryGrey}!important;
      }
    }
  }
`;
const Pagination = styled(AntPagination)`
  ${paginationStyles};
`;

export default Pagination;
